// Local storage keys
export const LOCAL_STORAGE_KEYS = {
    SIDEBAR_EXPANDED: "sidebar-expanded",
    SIDEBAR_OPEN_MENUS: "sidebar-open-menus",
  } as const;